import React from "react";

const IconGlobal = ({ color = "black", width = "24px", height = "24px" }) => {
  return (
    <div style={{ width: width, height: height }}>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        class="ionicon"
        width="40px"
        height="40px"
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
          fill="none"
          stroke={color}
          stroke-miterlimit="50"
          stroke-width="50"
        >
          <path
            d="M2523 4450 c-259 -29 -515 -123 -731 -267 -95 -63 -113 -89 -88 -128
25 -39 56 -31 165 40 119 78 231 132 361 173 160 51 149 51 111 6 -79 -95
-151 -218 -219 -375 -19 -45 -21 -46 -72 -52 -98 -12 -184 -84 -216 -181 -21
-62 -15 -156 14 -213 19 -36 104 -123 121 -123 4 0 1 -51 -5 -112 -7 -62 -15
-161 -19 -220 l-7 -108 -375 0 -376 0 7 88 c6 80 5 90 -13 106 -28 25 -73 17
-89 -16 -7 -16 -15 -86 -18 -170 -25 -599 277 -1154 798 -1467 278 -167 621
-247 946 -220 142 11 161 14 287 46 113 29 221 69 248 91 33 29 11 92 -33 92
-10 0 -71 -18 -137 -40 -157 -53 -165 -52 -116 8 212 256 357 723 380 1222 l6
140 379 0 379 0 -7 -67 c-17 -186 -72 -380 -155 -548 -54 -111 -58 -142 -20
-161 42 -21 63 -3 118 102 170 325 220 743 133 1111 -37 154 -89 289 -167 426
l-44 78 21 26 c24 30 50 113 50 158 0 109 -85 225 -189 260 -67 22 -148 16
-212 -15 l-46 -23 -54 41 c-173 129 -426 234 -670 277 -102 19 -347 27 -446
15z m117 -835 l0 -725 -290 0 -290 0 0 74 c0 74 15 256 26 309 4 17 12 27 23
27 45 0 122 33 165 71 70 62 91 108 91 204 0 70 -4 87 -30 134 -18 33 -47 67
-73 85 -50 35 -50 30 18 172 85 176 195 301 311 353 24 12 45 21 47 21 1 0 2
-326 2 -725z m192 694 c177 -90 347 -399 432 -783 38 -171 76 -474 76 -607 l0
-29 -290 0 -290 0 0 720 c0 804 -7 739 72 699z m413 -69 c127 -51 251 -118
342 -186 l32 -24 -14 -41 c-45 -127 6 -268 122 -336 52 -30 161 -43 214 -24
39 14 41 12 108 -124 86 -172 136 -348 156 -547 l7 -68 -380 0 -379 0 -6 138
c-23 500 -166 969 -367 1212 -28 32 -50 61 -50 64 0 8 134 -32 215 -64z m700
-209 c100 -57 101 -201 4 -274 -68 -50 -182 -20 -226 58 -28 50 -29 97 -3 149
43 88 139 116 225 67z m-1779 -312 c81 -39 112 -130 72 -209 -31 -60 -77 -90
-140 -90 -59 0 -98 19 -132 63 -60 78 -34 188 54 234 53 28 91 29 146 2z
m-226 -978 c0 -59 21 -291 36 -396 55 -396 196 -767 357 -942 l42 -46 -40 7
c-125 23 -329 113 -480 213 -127 84 -316 272 -402 398 -147 218 -242 478 -260
717 l-6 78 377 0 376 0 0 -29z m700 -109 l0 -139 -42 -12 c-64 -20 -142 -104
-164 -176 -42 -147 32 -292 179 -345 l27 -10 0 -310 c0 -241 -3 -310 -12 -310
-33 1 -106 46 -164 102 -136 130 -239 339 -318 642 -46 178 -86 468 -86 629
l0 67 290 0 290 0 0 -138z m700 116 c0 -13 -5 -84 -10 -158 -39 -515 -185
-947 -389 -1150 -51 -51 -142 -110 -171 -110 -7 0 -10 103 -10 309 l0 309 54
26 c63 31 110 80 138 144 25 56 22 168 -7 227 -26 53 -86 109 -140 132 l-45
18 0 138 0 137 290 0 290 0 0 -22z m-536 -406 c85 -80 68 -207 -34 -260 -109
-56 -230 19 -230 142 0 81 46 139 123 155 46 10 108 -6 141 -37z"
          />
          <path
            d="M675 4395 c-373 -69 -634 -337 -612 -630 15 -203 148 -376 372 -485
115 -56 182 -75 323 -91 160 -18 327 8 490 78 l83 35 91 -61 c49 -33 93 -61
98 -61 4 0 20 10 35 21 32 26 31 30 -20 152 l-36 88 29 37 c139 179 152 406
34 588 -165 254 -539 393 -887 329z m270 -105 c181 -20 325 -82 438 -189 181
-171 193 -388 32 -581 -32 -38 -35 -48 -30 -81 l6 -37 -38 13 c-36 12 -41 11
-115 -26 -110 -55 -204 -80 -335 -86 -241 -12 -452 58 -592 197 -208 206 -171
492 87 664 124 82 240 117 442 135 8 0 56 -4 105 -9z"
          />
          <path
            d="M448 3958 c-30 -24 -31 -56 -4 -83 l25 -25 383 0 c423 0 428 1 428
60 0 59 -4 60 -430 60 -294 0 -390 -3 -402 -12z"
          />
          <path
            d="M433 3684 c-15 -24 -15 -29 -2 -53 l15 -26 398 -3 c361 -2 401 -1
418 14 23 22 23 56 0 77 -17 15 -60 17 -415 17 l-397 0 -17 -26z"
          />
          <path
            d="M3560 1870 c-11 -11 -20 -24 -20 -29 0 -5 18 -54 40 -109 l41 -101
-36 -47 c-74 -97 -105 -188 -105 -310 0 -154 57 -274 189 -396 321 -297 919
-284 1226 26 174 176 212 403 102 610 -43 83 -162 200 -257 253 -261 146 -599
161 -869 37 l-80 -36 -88 61 c-48 34 -96 61 -106 61 -9 0 -26 -9 -37 -20z
m935 -124 c33 -9 102 -37 153 -62 319 -156 391 -481 158 -709 -234 -230 -700
-263 -989 -71 -79 52 -153 136 -190 213 -29 61 -32 78 -32 158 0 80 4 97 31
156 18 37 49 86 70 109 33 37 39 49 37 85 l-1 42 39 -11 c36 -9 45 -7 97 21
60 32 158 67 233 83 69 14 324 5 394 -14z"
          />
          <path
            d="M3856 1454 c-21 -21 -20 -57 2 -77 17 -15 60 -17 410 -17 379 0 393
1 412 20 24 24 25 38 4 68 l-15 22 -399 0 c-349 0 -401 -2 -414 -16z"
          />
          <path
            d="M3862 1204 c-25 -17 -29 -51 -8 -80 14 -18 30 -19 411 -19 l397 0 19
24 c24 30 24 46 -1 71 -19 19 -33 20 -408 20 -335 0 -391 -2 -410 -16z"
          />
        </g>
      </svg>
    </div>
  );
};

export default IconGlobal;
